module.exports = __webpack_public_path__ + "static/img/ajax-loader.76f4666.gif";


//////////////////
// WEBPACK FOOTER
// ./static/ibcoinexx/img/ajax-loader.gif
// module id = tiW2
// module chunks = 22